import React from 'react';
import { cn } from '../../utils/cn';
import { ENTRY_CLOSED } from './content';
import styles from './EntryClosedNotice.module.css';

// エントリー受付終了の告知パネル。
// hero はファーストビュー用のコンパクト表示、form はエントリーセクション用の通常表示。
export default function EntryClosedNotice({ className, variant = 'form' }) {
  const copy = ENTRY_CLOSED[variant] ?? ENTRY_CLOSED.form;

  return (
    <aside className={cn(styles.notice, styles[variant], className)}>
      <p className={styles.title}>{copy.title}</p>
      <span className={styles.rule} aria-hidden="true" />
      <p className={styles.message}>{copy.message}</p>
    </aside>
  );
}
